import { connect } from 'react-redux'
import { reduxForm } from 'redux-form/immutable'
import { createStructuredSelector } from 'reselect'
import { withTranslation } from 'react-i18next'

import { parsePhoneBeforeSend } from 'helpers/parsePhone'
import { postInvite } from 'store/entities/identity/actions'
import {
  getOrganizationSettingsByDomain,
  getOrganizationSettingsPendingByDomain,
  isPhoneIsRequiredForOrganization,
} from 'store/entities/organizationSettings/selectors'
import { isShowLoginInformationModal } from 'store/entities/localSettings/selectors'
import { closeShowLoginInformationModal } from 'store/entities/localSettings/actions'
import { ISO_CODE, USA_ISO } from 'app/constants/phoneCountryCodes'
import Start from './Start'
import { modal } from 'store/entities/modal/actions'
import { googleTrack } from 'store/entities/analytics/googleAnalytics'

const mapStateToProps = createStructuredSelector({
  organizationSettings: getOrganizationSettingsByDomain,
  pending: getOrganizationSettingsPendingByDomain,
  isShowLoginInformationModal: isShowLoginInformationModal,
  isPhoneRequired: isPhoneIsRequiredForOrganization,
})

const mapDispatchToProps = {
  showModal: modal.show,
  closeShowLoginInformationModal,
}

const mergeProps = ({ organizationSettings, ...stateProps }, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  pageType: organizationSettings.getIn(['promoPageSettings', 'pageType']),
  formTitle: organizationSettings.getIn(['promoPageSettings', 'formTitle']),
  formSubTitle: organizationSettings.getIn(['promoPageSettings', 'formSubTitle']),
  isPromoPageActive: organizationSettings.getIn(['promoPageSettings', 'isPromoPageActive']),
  phoneIsRequired: organizationSettings.getIn(['promoPageSettings', 'phoneIsRequired']),
  image: organizationSettings.getIn(['promoPageSettings', 'image']),
  title: organizationSettings.getIn(['promoPageSettings', 'title']),
  subTitle: organizationSettings.getIn(['promoPageSettings', 'subTitle']),
  onSubmit: (values, dispatch) => {
    const iso = values.get('phoneISO')
    const phone = values.get('phone') && parsePhoneBeforeSend(`${ISO_CODE[iso]}${values.get('phone')}`)
    googleTrack(window.location.host + window.location.pathname, 'Promo:SignUpForm', null, 'Start ProHabits')
    dispatch(
      postInvite({
        ...values.toJS(),
        phone,
        organizationId: organizationSettings.getIn(['organization', 'id']),
      })
    )
  },
  onBlurCustom: (event, newValue, previousValue, name) => {
    googleTrack(window.location.host + window.location.pathname, 'Promo:SignUpForm', null, name)
  },
})

const formProps = {
  form: 'START_LANDING_FORM',
  initialValues: { phoneISO: USA_ISO },
  destroyOnUnmount: false,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(reduxForm(formProps)(withTranslation('common')(Start)))
